import { DrugItemDrawerTradeNamesSection } from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import { useActiveSubstanceDrugContext } from '@/shared/contexts/active-substance-drug'
import { Tabs } from '@chakra-ui/react'

export function TradeNamesTab() {
  const {tradeNames} = useActiveSubstanceDrugContext()

  return (
    <Tabs.Content value="trade-names">
      <DrugItemDrawerTradeNamesSection tradeNames={tradeNames} />
    </Tabs.Content>
  )
}
